module.exports = __webpack_public_path__ + "static/media/co-funded-by-the-eu-vertical.50c086be.jpg";